import { useLocalization } from "@i18n";
import { useUserContext } from "@shared/contexts";

import { ComplexAdminsSection } from "../components/organisms";

const AdminAccessPage = () => {
  const { translate } = useLocalization();
  const { user: me } = useUserContext();

  // Permissões espelhadas das regras do backend (docs/permissions.md, na raiz do
  // monorepo) após a remoção do papel `superAdmin`:
  // - GET v1/admin/complex-admins (Y=13): owner | ownerViewer (escopo total).
  // - POST/DELETE complex-admin (Y=12/14): owner only.
  //
  // owner/ownerViewer são espelhados master↔tenant, então `me.role` já basta
  // para o gate desta aba. complexAdmin/user puro (`me.role === "user"`) não
  // gerenciam acessos — caem no estado "forbidden" (e o AdminLayout já esconde a
  // aba via canSeeAccessTab).
  const isMasterReader = me?.role === "owner" || me?.role === "ownerViewer";
  const isOwner = me?.role === "owner";

  // Complex Admins: owner/ownerViewer leem; só owner escreve.
  const canReadComplexAdmins = isMasterReader;
  const canWriteComplexAdmins = isOwner;

  const showAnything = canReadComplexAdmins;

  return (
    <div className="flex flex-col gap-4">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold">
          {translate("admin.access.page.title")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {translate("admin.access.page.subtitle")}
        </p>
      </header>

      {!showAnything ? (
        <p className="text-sm text-muted-foreground">
          {translate("admin.access.forbidden")}
        </p>
      ) : (
        <div className="flex flex-col gap-6">
          <ComplexAdminsSection
            canRead={canReadComplexAdmins}
            canWrite={canWriteComplexAdmins}
          />
        </div>
      )}
    </div>
  );
};

export default AdminAccessPage;
